import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import Bowser from 'bowser';
import { RiFileCopyLine } from "react-icons/ri";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #fff;
  color: #333;
  font-family: 'Arial', sans-serif;
  text-align: center;
  padding: 20px;
`;

const Button = styled.button`
  margin-top: 10px;
  padding: 10px 20px;
  font-size: 1rem; 
  color: #fff;
  background-color: #0066ff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #9d9d9d;
  }
`;


const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  max-width: 1200px;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(169, 169, 169, 1.0);
  padding: 20px;
  font-size: 1rem;
  flex: 1;
`;
/*
const Title = styled.h1`
  font-size: 2rem;
  color: #333;
  width: 100%;
  text-align: center;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    font-size: 1.5rem;
  }

  @media (max-width: 600px) {
    font-size: 1.25rem;
  }
`;
*/
const Info = styled.p`
  font-size: 1rem;
  color: #555;

  @media (max-width: 600px) {
    font-size: 0.875rem;
  }
`;

const InfoTitle = styled.h2`
    font-size: 1.5rem;
    color: #333;
    width: 100%;
    text-align: center;
    margin-bottom: 20px;

  @media (max-width: 600px) {
    font-size: 0.875rem;
  }
`;


const App = () => {
  const [ipData, setIpData] = useState(null);
  const [browserInfo, setBrowserInfo] = useState(null);

  useEffect(() => {
    const getIpData = async () => {
      try {
        const response = await axios.get('https://ipapi.co/json/');
        setIpData(response.data);
      } catch (error) {
        console.error('Error fetching IP data', error);
      }
    };

    const getBrowserInfo = () => {
      const userAgent = navigator.userAgent;
      const browser = Bowser.getParser(window.navigator.userAgent);
      const language = navigator.language;
      const cookiesEnabled = navigator.cookieEnabled;
      const memory = navigator.deviceMemory || 'N/A';
      const screenOrientation = window.screen.orientation ? window.screen.orientation.type : 'N/A';
      const screenResolution = `${window.screen.width}x${window.screen.height}`;
      const aspectRatio = (window.screen.width / window.screen.height).toFixed(2);
      const devicePixelRatio = window.devicePixelRatio;
      const colorDepth = window.screen.colorDepth;
      const innerSize = `${window.innerWidth}x${window.innerHeight}`;
      const outerSize = `${window.outerWidth}x${window.outerHeight}`;
      const videoSupport = getVideoSupport();

      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
      const connectionType = connection.type || 'N/A';
      const effectiveConnectionType = connection.effectiveType || 'N/A';
      const rtt = connection.rtt || 'N/A';

      const connectionSpeedRanges = {
        '2g': '50-250 Kbps',
        '3g': '256 Kbps - 2 Mbps',
        '4g': '2 Mbps - 1 Gbps',
        '5g': '50 Mbps - 20 Gbps',
        'wifi': 'Varies (usually 11-1000 Mbps)',
        'bluetooth': 'Varies (usually 1-3 Mbps)',
        'ethernet': 'Varies (usually 10 Mbps - 100 Gbps)',
        'other': 'Unknown'
      };

      const effectiveConnectionSpeedRange = connectionSpeedRanges[effectiveConnectionType] || 'Unknown';

      return {
        userAgent,
        language,
        cookiesEnabled,
        memory,
        screenOrientation,
        screenResolution,
        aspectRatio,
        devicePixelRatio,
        colorDepth,
        innerSize,
        outerSize,
        videoSupport,
        connectionType,
        effectiveConnectionType,
        rtt,
        effectiveConnectionSpeedRange,
        browser: browser.getBrowserName(),
        browserVersion: browser.getBrowserVersion(),
        platform: browser.getPlatformType(),
        engine: browser.getEngineName(),
        os: browser.getOSName(),
        osVersion: browser.getOSVersion()
      };
    };

    const getVideoSupport = () => {
      const video = document.createElement('video');
      const formats = [
        { type: 'video/mp4', label: 'MP4' },
        { type: 'video/quicktime', label: 'MOV' },
        { type: 'video/x-ms-wmv', label: 'WMV' },
        { type: 'video/x-msvideo', label: 'AVI' },
        { type: 'video/mp4', label: 'AVCHD' },
        { type: 'video/x-flv', label: 'FLV' },
        { type: 'video/x-f4v', label: 'F4V' },
        { type: 'application/x-shockwave-flash', label: 'SWF' },
        { type: 'video/x-matroska', label: 'MKV' },
        { type: 'video/webm', label: 'WEBM' },
        { type: 'video/mp4', label: 'HTML5' },
      ];

      const support = formats.reduce((acc, format) => {
        acc[format.label] = video.canPlayType(format.type) ? 'Sí' : 'No';
        return acc;
      }, {});

      return support;
    };

    getIpData();
    setBrowserInfo(getBrowserInfo());
  }, []);

  const handleCopyToClipboard = (info) => {
    const formattedInfo = `
DATOS CONEXION
IP Actual: ${ipData.ip}
VPN Detectada: ${ipData.security && ipData.security.is_vpn ? 'Sí' : 'No'}
País: ${ipData.country_name}
Región: ${ipData.region}
Ciudad: ${ipData.city}
Latitud: ${ipData.latitude}
Longitud: ${ipData.longitude}
ISP Actual: ${ipData.org}
Tipo de Conexión Efectiva: ${info.effectiveConnectionType}
Rango de Velocidad Efectiva: ${info.effectiveConnectionSpeedRange}
RTT: ${info.rtt} ms

DATOS BROWSER
Nombre Browser: ${info.browser}
Versión Browser: ${info.browserVersion}
Motor de Renderizado: ${info.engine}
Idioma: ${info.language}
Plataforma: ${info.platform}
User Agent: ${info.userAgent}
Cookies Habilitadas: ${info.cookiesEnabled ? 'Sí' : 'No'}
Orientación de la Pantalla: ${info.screenOrientation}
Resolución de la Pantalla: ${info.screenResolution}
Relación de Aspecto: ${info.aspectRatio}
Device Pixel Ratio: ${info.devicePixelRatio}
Color Depth: ${info.colorDepth}
Tamaño de la Ventana (Inner): ${info.innerSize}
Tamaño de la Ventana (Outer): ${info.outerSize}
Soporte de Video: ${Object.entries(info.videoSupport).map(([format, support]) => `${format}: ${support}`).join(', ')}

DATOS ADICIONALES
Sistema Operativo: ${info.os}
Versión del Sistema Operativo: ${info.osVersion}
Memoria RAM: ${info.memory} GB

Visita: https://click.com.ar
`;

    navigator.clipboard.writeText(formattedInfo).then(() => {
      //alert('Datos copiados al portapapeles');
    }).catch((err) => {
      console.error('Error al copiar al portapapeles', err);
    });
  };

  const handleCopyConectionDataToClipboard = (info) => {
    const formattedInfo = `
DATOS CONEXION
IP Actual: ${ipData.ip}
VPN Detectada: ${ipData.security && ipData.security.is_vpn ? 'Sí' : 'No'}
País: ${ipData.country_name}
Región: ${ipData.region}
Ciudad: ${ipData.city}
Latitud: ${ipData.latitude}
Longitud: ${ipData.longitude}
ISP Actual: ${ipData.org}
Tipo de Conexión Efectiva: ${info.effectiveConnectionType}
Rango de Velocidad Efectiva: ${info.effectiveConnectionSpeedRange}
RTT: ${info.rtt} ms

Visita: https://click.com.ar
`;

    navigator.clipboard.writeText(formattedInfo).then(() => {
      //alert('Datos copiados al portapapeles');
    }).catch((err) => {
      console.error('Error al copiar al portapapeles', err);
    });
  };


  const handleCopyBrowserDataToClipboard = (info) => {
    const formattedInfo = `
DATOS BROWSER
Nombre Browser: ${info.browser}
Versión Browser: ${info.browserVersion}
Motor de Renderizado: ${info.engine}
Idioma: ${info.language}
Plataforma: ${info.platform}
User Agent: ${info.userAgent}
Cookies Habilitadas: ${info.cookiesEnabled ? 'Sí' : 'No'}
Orientación de la Pantalla: ${info.screenOrientation}
Resolución de la Pantalla: ${info.screenResolution}
Relación de Aspecto: ${info.aspectRatio}
Device Pixel Ratio: ${info.devicePixelRatio}
Color Depth: ${info.colorDepth}
Tamaño de la Ventana (Inner): ${info.innerSize}
Tamaño de la Ventana (Outer): ${info.outerSize}
Soporte de Video: ${Object.entries(info.videoSupport).map(([format, support]) => `${format}: ${support}`).join(', ')}

Visita: https://click.com.ar
`;

    navigator.clipboard.writeText(formattedInfo).then(() => {
      //alert('Datos copiados al portapapeles');
    }).catch((err) => {
      console.error('Error al copiar al portapapeles', err);
    });
  };

  const handleCopyAditionalDataToClipboard = (info) => {
    const formattedInfo = `
DATOS ADICIONALES
Sistema Operativo: ${info.os}
Versión del Sistema Operativo: ${info.osVersion}
Memoria RAM: ${info.memory} GB

Visita: https://click.com.ar
`;

    navigator.clipboard.writeText(formattedInfo).then(() => {
      //alert('Datos copiados al portapapeles');
    }).catch((err) => {
      console.error('Error al copiar al portapapeles', err);
    });
  };


  return (
      <Container>
        <Columns>
          <Card>
            <InfoTitle><strong>Datos Conexion</strong></InfoTitle>

            {ipData && (
                <>
                  <Info><strong>IP Actual:</strong> {ipData.ip}</Info>
                  <Info><strong>VPN Detectada:</strong> {ipData.security && ipData.security.is_vpn ? 'Sí' : 'No'}</Info>
                  <Info><strong>País:</strong> {ipData.country_name}</Info>
                  <Info><strong>Región:</strong> {ipData.region}</Info>
                  <Info><strong>Ciudad:</strong> {ipData.city}</Info>
                  <Info><strong>Latitud:</strong> {ipData.latitude}</Info>
                  <Info><strong>Longitud:</strong> {ipData.longitude}</Info>
                  <Info><strong>ISP Actual:</strong> </Info>
                  <Info>{ipData.org}</Info>
                </>
            )}

            {browserInfo && (
                <>
                  <Info><strong>Tipo de Conexión Efectiva:</strong> {browserInfo.effectiveConnectionType}</Info>
                  <Info><strong>Rango de Velocidad Efectiva:</strong></Info>
                  <Info> {browserInfo.effectiveConnectionSpeedRange}</Info>
                  <Info><strong>RTT:</strong> {browserInfo.rtt} ms</Info>
                </>
            )}
            <Button onClick={() => handleCopyConectionDataToClipboard(browserInfo)}>
              <RiFileCopyLine /> Copiar Datos Conexion
            </Button>
          </Card>

          <Card>
            <InfoTitle><strong>Datos Browser</strong></InfoTitle>
            {browserInfo && (
                <>
                  <Info><strong>Nombre Browser:</strong> {browserInfo.browser}</Info>
                  <Info><strong>Versión Browser:</strong> {browserInfo.browserVersion}</Info>
                  <Info><strong>Motor de Renderizado:</strong> {browserInfo.engine}</Info>
                  <Info><strong>Idioma:</strong> {browserInfo.language}</Info>
                  <Info><strong>Plataforma:</strong> {browserInfo.platform}</Info>
                  <Info><strong>User Agent:</strong> {browserInfo.userAgent}</Info>
                  <Info><strong>Cookies Habilitadas:</strong> {browserInfo.cookiesEnabled ? 'Sí' : 'No'}</Info>
                  <Info><strong>Orientación de la Pantalla:</strong> {browserInfo.screenOrientation}</Info>
                  <Info><strong>Resolución de la Pantalla:</strong> {browserInfo.screenResolution}</Info>
                  <Info><strong>Relación de Aspecto:</strong> {browserInfo.aspectRatio}</Info>
                  <Info><strong>Device Pixel Ratio:</strong> {browserInfo.devicePixelRatio}</Info>
                  <Info><strong>Color Depth:</strong> {browserInfo.colorDepth}</Info>
                  <Info><strong>Tamaño de la Ventana (Inner):</strong> {browserInfo.innerSize}</Info>
                  <Info><strong>Tamaño de la Ventana (Outer):</strong> {browserInfo.outerSize}</Info>
                  <Info><strong>Soporte de Video:</strong></Info>
                  <p>
                  {Object.entries(browserInfo.videoSupport).map(([format, support]) => (
                      <><strong>{format}:</strong> {support},  </>
                  ))}</p>
                </>
            )}
            <Button onClick={() => handleCopyBrowserDataToClipboard(browserInfo)}>
              <RiFileCopyLine /> Copiar Datos Browser
            </Button>
          </Card>

          <Card>
            <InfoTitle><strong>Datos Adicionales</strong></InfoTitle>
            {browserInfo && (
                <>
                  <Info><strong>Sistema Operativo:</strong> {browserInfo.os || 'N/A'}</Info>
                  <Info><strong>OS version:</strong> {browserInfo.osVersion || 'N/A'}</Info>
                  <Info><strong>Memoria RAM:</strong> {browserInfo.memory} GB</Info>
                </>
            )}
            <Button onClick={() => handleCopyAditionalDataToClipboard(browserInfo)}>
              <RiFileCopyLine /> Copiar Datos Adicionales
            </Button>
          </Card>
        </Columns>
        <Button onClick={() => handleCopyToClipboard(browserInfo)}>
          <RiFileCopyLine /> Copiar todo
        </Button>
      </Container>
  );
};

export default App;
